import { api } from "../../utils/api";
export const postReportPayment = async (data) => {
  try {
    const response = await api.post(`/report/payment-statement`, data);
    return response.data;
  } catch (error) {
    // console.error("Error fetching payment report:", error);
    throw error;
  }
}